module.exports = __webpack_public_path__ + "static/img/candidate-care.cb985d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/thumbs/candidate-care.png
// module id = Xwg0
// module chunks = 0